module.exports = __webpack_public_path__ + "static/image/company/m/image_declaration_2@3x.jpg?8f108551";